import React from "react";
import { useState } from "react";
import MainContent from "./MainContent";
import UserButton from "./UserButton";
import LanguageSwitcher from "./LanguageSwitcher";
import RoofRoxSidebar from "./RoofRoxSidebar";
import PropTypes from "prop-types";

const Dashboard = ({ setToken }) => {
  const logout = (e) => {
    e.preventDefault();
    setToken("");
  };

  const getUser = () => {
    const tokenString = sessionStorage.getItem("user");
    const userToken = JSON.parse(tokenString);
    return userToken;
  };

  const [user] = useState(getUser());

  return (
    <div className="h-screen grid grid-rows-[auto_minmax(0,1fr)]">
      <div className="p-2">
        <div className="float-left px-2">
          <img className="hover:opacity-50 h-8 w-32" src="./Roofrox.png" alt="www.RoofRox.it" />  
        </div>
        <div className="float-left px-2 py-3">
          <p className="release-label">r. 2024.9.5</p>
        </div>
        <div className="float-right px-2">
          <button className="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1.5 px-4 border border-gray-400 rounded shadow" onClick={logout}>
            Logout
          </button>
        </div>
        <div className="float-right px-2">
          <UserButton code={user} />
        </div>
        <div className="float-right px-2 py-2">
          <LanguageSwitcher></LanguageSwitcher>
        </div>
      </div>
      <div className="grid grid-flow-col">
        <div className="bg-slate-50">
          <RoofRoxSidebar />
        </div>
        <div className="bg-slate-50 p-2">
          <MainContent />
        </div>
      </div>
    </div>

    // https://stackoverflow.com/questions/71616561/css-tailwind-grid-height-100vh-not-working
  );
};

Dashboard.propTypes = {
  setToken: PropTypes.func.isRequired,
};

export default Dashboard;
